(() => {
  "use strict";

  const moneyFormat = (cents) => "₹" + (cents / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 });

  /* ---------- gallery ---------- */
  // galleryMain is the container div (kept for future overlays/layout hooks);
  // galleryMainImg is the new real <img> that replaced the old CSS
  // background-image. All main-gallery swaps now update the <img>'s src.
  const galleryMain = document.getElementById("pdpGalleryMain");
  const galleryMainImg = document.getElementById("pdpGalleryMainImg");
  const galleryBrief = document.getElementById("pdpGalleryBrief");
  const galleryTag = document.getElementById("pdpGalleryTag");
  const thumbs = document.querySelectorAll(".pdp-thumb");

  // Swap the main gallery <img> to a new URL. Clears srcset so the browser
  // honors the newly-assigned src at any viewport, rather than continuing to
  // pick from the initial-load responsive set (which still points at the
  // first image's variants). Also updates the sizes hint minimally.
  function setMainImage(url) {
    if (!galleryMainImg || !url) return;
    galleryMainImg.srcset = "";
    galleryMainImg.src = url;
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const img = thumb.dataset.img;
      const tag = thumb.dataset.tag;
      const brief = thumb.dataset.brief;

      setMainImage(img);
      if (galleryBrief) galleryBrief.textContent = brief || "";
      if (galleryTag) galleryTag.textContent = tag || "";

      thumbs.forEach((t) => t.classList.remove("active"));
      thumb.classList.add("active");
    });
  });

  /* ---------- variant selection ---------- */
  const variantWrapper = document.getElementById("pdpVariants");
  const productDataEl = document.getElementById("pdpProductJSON");
  const variantIdInput = document.getElementById("pdpVariantId");
  const priceEl = document.getElementById("pdpPrice");
  const stockEl = document.getElementById("pdpStock");
  const floatPriceEl = document.getElementById("pdpFloatPrice");
  const addBtn = document.getElementById("pdpAddBtn");
  const floatAdd = document.getElementById("pdpFloatAdd");

  let productData = null;
  if (productDataEl) {
    try {
      productData = JSON.parse(productDataEl.textContent);
    } catch (e) {
      productData = null;
    }
  }

  const selectedOptions = productData
    ? (productData.variants.find((v) => v.id === Number(variantIdInput.value))?.options || []).slice()
    : [];

  function findMatchingVariant() {
    if (!productData) return null;
    return productData.variants.find((v) =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }

  function applyVariant(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    const available = variant.available;
    const priceText = moneyFormat(variant.price);

    if (priceEl) priceEl.textContent = priceText;
    if (floatPriceEl) floatPriceEl.textContent = priceText;
    if (stockEl) stockEl.textContent = available ? "In stock" : "Sold out";

    const qty = Number(document.getElementById("pdpQtyInput")?.value || 1);
    [addBtn, floatAdd].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !available;
      if (!available) {
        btn.textContent = "Sold Out";
      } else if (btn === addBtn) {
        btn.textContent = "Add to Bag · " + moneyFormat(variant.price * qty);
      } else {
        btn.textContent = "Add to Bag";
      }
    });

    if (addBtn) addBtn.dataset.unitPrice = variant.price;

    if (variant.featured_image && variant.featured_image.src) {
      setMainImage(variant.featured_image.src);
    }
  }

  if (variantWrapper) {
    variantWrapper.querySelectorAll(".pdp-variant-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const optionIndex = Number(btn.dataset.optionIndex);
        const value = btn.dataset.value;

        selectedOptions[optionIndex] = value;

        variantWrapper
          .querySelectorAll('.pdp-variant-btn[data-option-index="' + optionIndex + '"]')
          .forEach((b) => b.classList.toggle("active", b === btn));

        applyVariant(findMatchingVariant());
      });
    });
  }

  /* ---------- quantity ---------- */
  const qtyVal = document.getElementById("pdpQtyVal");
  const qtyInput = document.getElementById("pdpQtyInput");
  const qtyDown = document.getElementById("pdpQtyDown");
  const qtyUp = document.getElementById("pdpQtyUp");

  function currentUnitPrice() {
    return Number(addBtn?.dataset.unitPrice || 0);
  }

  function updateQty(delta) {
    let q = parseInt(qtyVal.textContent, 10) + delta;
    if (q < 1) q = 1;
    if (q > 10) q = 10;
    qtyVal.textContent = q;
    if (qtyInput) qtyInput.value = q;

    if (addBtn && !addBtn.disabled) {
      addBtn.textContent = "Add to Bag · " + moneyFormat(currentUnitPrice() * q);
    }
  }

  if (qtyDown) qtyDown.addEventListener("click", () => updateQty(-1));
  if (qtyUp) qtyUp.addEventListener("click", () => updateQty(1));

  /* ---------- add to bag (AJAX) ----------
     Submits to /cart/add.js instead of a normal browser POST, then dispatches
     the theme's shared 'cart:update' event so the existing global TGC cart
     drawer (assets/cart-drawer-tgc.js) refreshes itself and opens — same
     event contract assets/product-form.js already uses elsewhere in the
     theme. No second drawer, no second AJAX-cart implementation. */
  const pdpForm = document.getElementById("pdpProductForm");
  const addError = document.getElementById("pdpAddError");
  let isSubmitting = false;

  function showAddError(message) {
    if (!addError) return;
    addError.textContent = message;
    addError.hidden = false;
  }

  function hideAddError() {
    if (!addError) return;
    addError.hidden = true;
    addError.textContent = "";
  }

  if (pdpForm) {
    pdpForm.addEventListener("submit", (e) => {
      e.preventDefault();
      if (isSubmitting) return;

      const submitButtons = [addBtn, floatAdd].filter(Boolean);
      if (submitButtons.some((btn) => btn.disabled)) return;

      isSubmitting = true;
      hideAddError();

      const originalLabels = submitButtons.map((btn) => btn.textContent);
      submitButtons.forEach((btn) => {
        btn.disabled = true;
        btn.textContent = "Adding…";
      });

      const formData = new FormData(pdpForm);

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          if (!ok || data.status) {
            throw new Error(data.description || data.message || "Could not add this item to your bag.");
          }

          document.dispatchEvent(
            new CustomEvent("cart:update", {
              bubbles: true,
              detail: { data: { source: "pdp-product-form" } },
            })
          );
        })
        .catch((err) => {
          showAddError(err.message || "Something went wrong. Please try again.");
        })
        .finally(() => {
          isSubmitting = false;
          submitButtons.forEach((btn, i) => {
            btn.disabled = false;
            btn.textContent = originalLabels[i];
          });
        });
    });
  }

  /* ---------- floating purchase tray ---------- */
  const floatTray = document.getElementById("pdpFloatTray");
  const purchasePanel = document.querySelector(".pdp-purchase");

  if (floatTray && purchasePanel) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        floatTray.classList.toggle("is-visible", !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: "-100px 0px 0px 0px" }
    );
    observer.observe(purchasePanel);
  }

  /* ---------- cart drawer ----------
     The drawer itself (open/close/quantity/remove) is now the shared global
     component — see assets/cart-drawer-tgc.js, loaded alongside this file.
     That script also keeps #pdpBagCount/#pdpCartHeadCount in sync. */

  /* ---------- share ---------- */
  const shareLink = document.getElementById("pdpShareLink");
  if (shareLink) {
    shareLink.addEventListener("click", (e) => {
      e.preventDefault();
      const url = shareLink.dataset.shareUrl;
      const title = shareLink.dataset.shareTitle;

      if (navigator.share) {
        navigator.share({ title, url }).catch(() => {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          const original = shareLink.textContent;
          shareLink.textContent = "Link copied";
          setTimeout(() => {
            shareLink.textContent = original;
          }, 1500);
        });
      }
    });
  }

  /* ---------- accordion ---------- */
  document.querySelectorAll(".pdp-accordion-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item = btn.closest(".pdp-accordion-item");
      const wasOpen = item.classList.contains("is-open");
      const glyph = btn.querySelector(".pdp-accordion-glyph");

      document.querySelectorAll(".pdp-accordion-item").forEach((el) => {
        el.classList.remove("is-open");
        const g = el.querySelector(".pdp-accordion-glyph");
        if (g) g.textContent = "+";
      });

      if (!wasOpen) {
        item.classList.add("is-open");
        if (glyph) glyph.textContent = "−";
      }
    });
  });

  /* ---------- mobile menu ---------- */
  const menuToggle = document.getElementById("pdpMenuToggle");
  const mobileMenu = document.getElementById("pdpMobileMenu");

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", () => {
      const isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute("aria-expanded", String(!isOpen));
    });
    mobileMenu.addEventListener("click", (e) => {
      if (e.target.tagName === "A") {
        mobileMenu.hidden = true;
        menuToggle.setAttribute("aria-expanded", "false");
      }
    });
  }
})();
